import app from 'flarum/forum/app';
import Modal, { IInternalModalAttrs } from 'flarum/common/components/Modal';
import ItemList from 'flarum/common/utils/ItemList';
import BountyOption from './BountyOption';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import type Product from '../../common/Product';
import type Discussion from 'flarum/common/models/Discussion';
import type Mithril from 'mithril';
import { ApiPayloadPlural } from 'flarum/common/Store';
import Price from '../../common/Price';

export interface IChooseBountyAmountAttrs extends IInternalModalAttrs {
  product: Product;
  for: Discussion;
}

export default class ChooseBountyAmount<CustomAttrs extends IChooseBountyAmountAttrs = IChooseBountyAmountAttrs> extends Modal<CustomAttrs> {
  private product!: Product;
  private for!: Discussion;
  private price?: Price;
  protected loading = true;

  oninit(vnode: Mithril.Vnode<CustomAttrs, this>) {
    super.oninit(vnode);

    this.product = this.attrs.product;
    this.for = this.attrs.for;

    app
      .request<ApiPayloadPlural>({
        url: app.forum.attribute('apiUrl') + '/blomstra-payments/stripe/products?for=bounty&id=' + this.product,
        method: 'GET',
      })
      .then((response) => {
        const products = (response.data || []) as unknown as Product[];

        this.product = products[0];
        this.price = this.product.attributes.prices[0];

        this.loading = false;

        m.redraw();
      });
  }

  className() {
    return 'PaymentOptionsModal Modal';
  }

  title() {
    return app.translator.trans('floxum-payments.forum.choose-bounty-amount-modal.title');
  }

  options() {
    const amounts = [25, 50, 100, 'other'];
    const options = new ItemList();

    amounts.forEach((price) => {
      options.add(
        String(price),
        <BountyOption currency={this.price!.cost.replace('0.00', '')} amount={price} product={this.product} for={this.for} />
      );
    });

    return options;
  }

  content() {
    return this.loading ? (
      <LoadingIndicator />
    ) : (
      <div className="Modal-body">
        <div className="Form Form--centered">
          <p className="helpText">
            {app.translator.trans('floxum-payments.forum.choose-bounty-amount-modal.description', { subject: this.for.title() })}
          </p>
          {this.options().toArray()}
        </div>
      </div>
    );
  }
}
